"use client";

import ChipCategory from "@/components/atoms/chipCategory/ChipCategory";
import { useAgentProvider } from "@/features/home/contexts/AgentProvider";
import { ITagData } from "@/interfaces/IAgentData";
import { IMenuBase } from "@/interfaces/IMenu";
import { cn } from "@/lib/utils";
import { FC, HTMLAttributes, useCallback, useEffect, useState } from "react";

interface FilterCategoryProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "children" | "defaultValue"> {
  onFiltersChange?: (filters: IMenuBase[]) => void;
}

// TODO: Refactor this component
const FilterCategory: FC<FilterCategoryProps> = ({ className, ...props }) => {
  const { allTags, setTags, setIsFiltering, setPage } = useAgentProvider();
  const [tagsFilter, setTagsFilter] = useState<ITagData[]>(allTags || []);

  const handleButtonClick = useCallback(
    (id: string) => {
      // Reset page to 1
      setPage?.(1);

      // Update tags filter
      const updatedTags = tagsFilter.map((tag) => {
        if (tag._id === id) {
          return {
            ...tag,
            isActive: !tag.isActive,
          };
        }

        return tag;
      });

      setTagsFilter(updatedTags);

      const selectedTags = updatedTags
        .filter((tag) => tag.isActive)
        .map((tag) => tag._id);
      if (selectedTags.length > 0) {
        setIsFiltering?.(true);
        setTags?.(selectedTags);
      } else {
        setIsFiltering?.(false);
        setTags?.(undefined);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tagsFilter],
  );

  useEffect(() => {
    if (allTags) {
      // Set all tags to active
      const updatedTags = allTags.map((tag) => ({
        ...tag,
        isActive: false,
      }));
      setTagsFilter(updatedTags);
    }
  }, [allTags]);

  return (
    <div
      className={cn(
        "max-w-[792px] flex gap-2 min-[451px]:gap-4 flex-wrap justify-center items-center",
        className,
      )}
      {...props}
    >
      {tagsFilter &&
        tagsFilter.length > 0 &&
        tagsFilter.map((_category, index) => (
          <ChipCategory
            key={`tag-${index}`}
            {..._category}
            onClick={() => handleButtonClick(_category._id)}
            isActive={_category.isActive}
          />
        ))}
    </div>
  );
};

export default FilterCategory;
